import { formatMessage } from "model/message";
const action = "ENABLE_HEAL";
const MAX_FREE_HEALTH = 10;

const messageText = (gain) => {
  return formatMessage("the cloth holds", { gain });
};

const attempt = () => {
  const result = {
    success: true,
    gain: {
      health: Math.ceil(Math.random() * MAX_FREE_HEALTH),
    },
    cost: {},
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const {
    party: { resources, history, phases },
  } = context;

  history.add({ action, result }, context);
  history.delta({ medicineWoman: true }, context);
  resources.delta({ health: result.gain.health }, context);

  // She names a price for the rest of it, so coin becomes a thing the player is
  // short of rather than a thing they have never heard of. The usual unlock waits
  // on holding some (phases.resourceListener) — here the affordance is the
  // information. No-op once coins are already showing.
  phases.enableResource(resources.attribs.coins.index);

  return { message: messageText(result.gain) };
};

const freeMedicine = (notifyDone) => ({
  title: "Take it",
  hotkey: "t",
  type: action,
  enabled: () => true,
  execute: (context) => {
    const result = attempt(context);
    const { message } = executeSideEffects(context, result);

    notifyDone();
    return { result: { message } };
  },
});

export default freeMedicine;
